/* Die Aktenvorschau füllt die Inlayfläche; nur das aktive Dokument oder die Nachricht scrollt. */
.person-digital-file-viewer,
.person-digital-file-viewer > .mu-loading-host,
.person-digital-file-viewer > .mu-loading-host > .mu-loading-dim {
  height: 100%;
  min-height: 0;
}

.person-digital-file-viewer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
